// Inspired by https://css-tricks.com/value-bubbles-for-range-inputs/
const initRangeSliders = () => {
  document.querySelectorAll("[data-range-slider]").forEach((slider) => {
    const $rangeElement = $(slider).find("[data-slider]");
    const $manualElement = $(slider).find("[data-manual]");
    const $valueBubble = $(slider).find("[data-value-bubble]");

    const setValueBubble = (value) => {
      const val = $rangeElement.val();
      const min = $rangeElement.prop('min') || 0;
      const max = $rangeElement.prop('max') || 100;
      const newValue = Number(((val - min) * 100) / (max - min));

      $valueBubble.text(value);
      // Sorta magic numbers based on size of the native UI thumb (otherwise it's never aligned)
      const magicNumbersForThumbCorrection = 8 - newValue * 0.15;
      $valueBubble.css('left', `calc(${newValue}% + (${magicNumbersForThumbCorrection}px))`);
    };

    $rangeElement.on("change", (e) => {
      $valueBubble.addClass("d-none");
      $manualElement.val(e.target.value);
      $manualElement.trigger("validate");
    });
    $rangeElement.on("input", (e) => {
      setValueBubble(e.target.valueAsNumber);
      $valueBubble.removeClass("d-none");
    });
    $manualElement.on("change", (e) => {
      $rangeElement.val(`${e.target.value}`);
      setValueBubble(
        slider.querySelector("[data-value-legend]"),
        e.target.value,
        $rangeElement.prop('max'),
      );
    });
  });
};

export { initRangeSliders };
